export default __webpack_public_path__ + "img/EF_250MA.23a35f558488b265099d3f8d70e868ad.jpg";